<div class="sc-light-box" (click)="closeLightBox()">
</div>
<ng-content></ng-content>